export default "__VITE_ASSET__Bcs$ByZV__"